module.exports = __webpack_public_path__ + "4f873f876736368fe699216bf8d94077.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/anna_thommen.jpg
// module id = 109
// module chunks = 0